import { createActions, createReducer } from 'reduxsauce'

const situacoesAtivos = [
    { value: '', label: 'Nenhum' },
    { value: 'S', label: 'Sim' },
    { value: 'N', label: 'Não' },
]
/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setReferenciaConsultaRemuneracao: ['referencia'],
    setOrgaoConsultaRemuneracao: ['orgao'],
    setCargoConsultaRemuneracao: ['cargo'],
    setVinculoConsultaRemuneracao: ['vinculo'],
    setFuncionarioConsultaRemuneracao: ['funcionario'],
    setSetorConsultaRemuneracao: ['setor'],
    setAtivoConsultaRemuneracao: ['ativo'],
    limpaFiltroConsultaRemuneracao: [],
    receberFiltroConsultaRemuneracao: ['filtroRecebido'],
})

const INITIAL_STATE = {
    referencia: [],
    orgao: [],
    cargo: [],
    vinculo: [],
    funcionario: '',
    setor: [],
    ativo: { value: situacoesAtivos[0].value, label: situacoesAtivos[0].label },
}

const setReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, referencia: action.referencia }
}

const setOrgao = (state = INITIAL_STATE, action) => {
    return { ...state, orgao: action.orgao }
}

const setCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: action.cargo }
}

const setVinculo = (state = INITIAL_STATE, action) => {
    return { ...state, vinculo: action.vinculo }
}

const setFuncionario = (state = INITIAL_STATE, action) => {
    return { ...state, funcionario: action.funcionario }
}

const setSetor = (state = INITIAL_STATE, action) => {
    return { ...state, setor: action.setor }
}

const setAtivo = (state = INITIAL_STATE, action) => {
    return { ...state, ativo: action.ativo }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_REFERENCIA_CONSULTA_REMUNERACAO]: setReferencia,
    [Types.SET_ORGAO_CONSULTA_REMUNERACAO]: setOrgao,
    [Types.SET_CARGO_CONSULTA_REMUNERACAO]: setCargo,
    [Types.SET_VINCULO_CONSULTA_REMUNERACAO]: setVinculo,
    [Types.SET_FUNCIONARIO_CONSULTA_REMUNERACAO]: setFuncionario,
    [Types.SET_SETOR_CONSULTA_REMUNERACAO]: setSetor,
    [Types.SET_ATIVO_CONSULTA_REMUNERACAO]: setAtivo,
    [Types.LIMPA_FILTRO_CONSULTA_REMUNERACAO]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_REMUNERACAO]: receberFiltro,
})
